import { Privilege } from './privilege.model';

export class Role {

    public description: string = '';
    public id: number;
    public name: string = '';
    public privileges: any[] = [];
    public show: any;
    public startPage: string = '';

    public static createFromJson(json: any): Role {
        if (json == null) {
            throw new Error('Role.createFromJson: json is null');
        }
        const instance = new Role();
        instance.description = json.description;
        instance.id = json.id;
        instance.name = json.name;
        instance.privileges = Array.isArray(json.privileges)
            ? json.privileges.map((privilege: any) => Privilege.createFromJson(privilege))
            : [];
        instance.show = json.show;
        instance.startPage = json.startPage;

        return instance;
    }

}
